var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkBackgroundPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23.0727,
    height: 19.6545,
    rx: 3.41818,
    fill: "#4322C6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5365 3.41797C8.00258 3.41797 5.12744 6.29303 5.12744 9.82703C5.12744 13.361 8.00258 16.2362 11.5365 16.2362C15.0705 16.2362 17.9456 13.361 17.9456 9.82703C17.9456 6.29303 15.0705 3.41797 11.5365 3.41797ZM15.2167 8.74448L11.1902 12.771C11.019 12.9422 10.7914 13.0364 10.5494 13.0364C10.3073 13.0364 10.0797 12.9422 9.90846 12.771L7.85632 10.7188C7.68511 10.5476 7.59081 10.32 7.59081 10.0779C7.59081 9.83579 7.68511 9.6082 7.85632 9.437C8.02746 9.26579 8.25504 9.17149 8.49721 9.17149C8.73931 9.17149 8.96696 9.26579 9.1381 9.43706L10.5493 10.8482L13.9348 7.46264C14.106 7.29144 14.3336 7.19721 14.5757 7.19721C14.8178 7.19721 15.0454 7.29144 15.2166 7.46264C15.5701 7.81616 15.5701 8.3911 15.2167 8.74448Z",
    fill: "#6F52E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkBackgroundPurple);
export default __webpack_public_path__ + "static/media/checkmark-background-purple.ffdc2e4bc4243adca283bbdbdec1104e.svg";
export { ForwardRef as ReactComponent };